const selectV2InjectionKey = Symbol("ElSelectV2Injection");

export { selectV2InjectionKey };
//# sourceMappingURL=token.mjs.map
